module.exports = __webpack_public_path__ + "img/icon-menu.749d1965.svg";